import {BaseRestService} from './base-rest.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from './app-settings.service';
import {Observable} from 'rxjs';
import {ArrayResponse, SendBackResult, SharedModule} from '..';
import {ServerForm} from '../models/servers';

@Injectable({providedIn: SharedModule})
export class CmsService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'CmsService'; }

  protected get isAnonymous(): boolean { return false; }

  // tslint:disable-next-line:no-any
  getCMS(uuid: string , productID: any , serviceType: any): Observable<SendBackResult<ArrayResponse<ServerForm>>> {
    return this.get<ArrayResponse<ServerForm>>(`/clients/${uuid}/CMS?productID=${productID}&serviceType=${serviceType}`);
  }
}
